export default "__VITE_ASSET__fpTCKFBD__"